import { updateTabindex } from '../../util/aria.js';
import { LitElement, property } from 'lit-element';
import { cssResult } from '../../util/css.js';
import { renderAttributes } from '../../util/dom.js';
import { removeListeners } from '../../util/event.js';
import { uniqueID } from '../../util/unique.js';
import { __decorate, __metadata } from 'tslib';
import { sharedStyles } from '../../style/shared.js';
import styles from './form-element-behavior.scss.js';

class FormElementBehavior extends LitElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.readonly = false;
        this.required = false;
        this.value = '';
        this.formElementId = uniqueID();
        this.listeners = [];
    }
    get validationMessage() {
        return this.$formElement.validationMessage;
    }
    get valid() {
        return this.validity != null ? this.validity.valid : true;
    }
    get validity() {
        return this.$formElement.validity;
    }
    get willValidate() {
        return this.$formElement.willValidate;
    }
    get form() {
        return this.$formElement.form;
    }
    checkValidity() {
        return this.$formElement.checkValidity();
    }
    setCustomValidity(error) {
        return this.$formElement.setCustomValidity(error);
    }
    firstUpdated(props) {
        super.firstUpdated(props);
        this.$formElement = this.queryFormElement();
        this.appendChild(this.$formElement);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        removeListeners(this.listeners);
    }
    updated(props) {
        super.updated(props);
        if (props.has('disabled')) {
            renderAttributes(this, { 'aria-disabled': this.disabled.toString() });
        }
        this.updateTabindex(props);
    }
    updateTabindex(props) {
        if (props.has('disabled')) {
            updateTabindex(this, this.disabled);
        }
    }
    getFormItemValue() {
        return this.$formElement != null ? this.$formElement.value : this.initialValue || '';
    }
    queryFormElement() {
        return this.shadowRoot.querySelector(`#${ this.formElementId }`);
    }
}
FormElementBehavior.styles = [
    sharedStyles,
    cssResult(styles)
];
__decorate([
    property({
        type: Boolean,
        reflect: true
    }),
    __metadata('design:type', Boolean)
], FormElementBehavior.prototype, 'disabled', void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true
    }),
    __metadata('design:type', Boolean)
], FormElementBehavior.prototype, 'readonly', void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true
    }),
    __metadata('design:type', Boolean)
], FormElementBehavior.prototype, 'required', void 0);
__decorate([
    property({ type: String }),
    __metadata('design:type', String)
], FormElementBehavior.prototype, 'name', void 0);
__decorate([
    property({ type: String }),
    __metadata('design:type', String)
], FormElementBehavior.prototype, 'value', void 0);

export { FormElementBehavior };
